import { css } from '@microsoft/fast-element';
import { genericFormStyling } from '../../../../styles/common/form.styles';

export const RfqFormStyles = css`
  ${genericFormStyling}
  zero-text-area,
  zero-text-field,
  zero-select,
  zero-number-field {
    width: 100%;
  }

  zero-select::part(listbox) {
    max-height: 250px;
  }

  .no-padding-bottom {
    padding-bottom: 0 !important;
  }

  .range-value {
    display: flex;
    gap: 9px;
    width: 100%;
    padding-bottom: 11px;
  }

  .minus-sign {
    padding-bottom: 10px;
    display: flex;
    align-items: center;
  }

  .auto-exec-message {
    font-size: 12px;
    color: var(--error);
    font-family: Roboto-Regular, Roboto, sans-serif;
  }

  .auto-exec-message-div {
    padding-top: 20px;
  }

  .key-metrics-section {
    font-size: 20px;
    color: var(--cascade-light-gray);
    font-family: Roboto-Regular, Roboto, sans-serif;
  }
`;
